import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import MonthlyContractState, {IMonthlyContract, MonthlyContractList} from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import axios from 'axios'
import httpRequest from '@/services/HttpRequestServiceWithToken'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'

const actions: ActionTree<MonthlyContractState, State> = {
  async getMonthlyContractList(
    { commit, dispatch, state }: ActionContext<MonthlyContractState, State>,
    options: object,
  ): Promise<void> {
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'monthly-contract', options, (res: MonthlyContractList) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
  async getMonthlyContracts(
    { commit, dispatch, state }: ActionContext<MonthlyContractState, State>,
    options: any,
  ): Promise<IMonthlyContract[]> {
    options.headers = {
      page: 1,
      limit: 9999,
      sortBy: 'createdAt',
      sortDesc: true,
      search: Buffer.from('').toString('base64'),
      filter: Buffer.from(JSON.stringify(options.headers.filter)).toString('base64'),
    }
    return httpRequest.getByLevel(
      process.env.VUE_APP_API_URL + '/v1', 'monthly-contract',
      options,
      (res: MonthlyContractList) => res.result)
  },
}

export default actions
